import React from "react";
import styled from "styled-components";
import {Container} from "../style/national";

const NationalContainer = ({shadowEffect, className, ...props}) => {
  return <Container className={className + (shadowEffect ? ' paper-shadow' : '')} {...props} />
}

const NationalContent = styled(NationalContainer)`
  max-width: var(--content-narrow-width-max);
  padding: 2rem 1.5rem 0;
  background: #fff;
  @media (min-width: 768px) {
    padding: 3rem 4rem 2rem;
    /* add a shadow to the content wrapper using pseudo elements */
    &.paper-shadow {
      ::before, ::after {
        content: '';
        position: absolute;
        top: 15px;
        z-index: -1;
        display: block;
        width: 20px;
        height: 200px;
        background: rgba(39, 44, 49, 0.15);
        filter: blur(5px);
      }

      ::before {
        left: -5px;
        transform: rotate(-5deg);
      }

      ::after {
        right: -5px;
        transform: rotate(5deg);
      }
    }
  }
  @media (min-width: 1200px) {
    padding: 4rem 6rem 2.5rem;
  }
`

export default NationalContent
